import React from "react";
import { FiUser, FiBell } from "react-icons/fi";

export default function EmpHeader() {
  return (
    <header className="h-16 bg-white shadow flex items-center justify-between px-6">
      {/* Left */}
      <h2 className="text-xl font-semibold text-gray-700">
        Employee Dashboard
      </h2>

      {/* Right Section */}
      <div className="flex items-center gap-6">

        {/* Notification */}
        <button className="relative">
          <FiBell size={22} className="text-gray-600" />
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] px-1 rounded-full">
            3
          </span>
        </button>

        {/* Profile */}
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold">
            E
          </div>
          <span className="text-gray-700 font-medium">Employee</span>
        </div>
      </div>
    </header>
  );
}
